import Nullstack from 'nullstack';
export default function IconShoppingCartOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-shopping-cart-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17 17a2 2 0 1 0 2 2"
  }), "   ", Nullstack.element("path", {
    d: "M17 17h-11v-11"
  }), "   ", Nullstack.element("path", {
    d: "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}